import {
  Typography,
  LinearProgress,
  CircularProgress,
  Zoom,
  Fade,
  Avatar,
  Box,
} from "@mui/material";
import { Cache } from "aws-amplify/utils";
import React, { lazy, Suspense, useState, useEffect } from "react";
import { useSelector, useDispatch, } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../actions/auth_actions";
import * as ROUTES from "../../constants/routes";
import config from "../../config";
// import Skillzminer from "../Skillzminer";

import Navigation from "./Navigation";

const Default = lazy(() => import("./Default"));
const MainDashboard = lazy(() => import("./MainDashboard"));
const WorkforcePlanning = lazy(() => import("../WorkforcePlanning"));
const Insights = lazy(() => import("../Insights"));
const Caseloads = lazy(() => import("../Caseload"));
const Admin = lazy(() => import("../Admin"));
const Candidates = lazy(() => import("../Candidates"));
const Profile = lazy(() => import("../Main/Profile"));
const Faq = lazy(() => import("../Main/Faq"));
const BlankPage = lazy(() => import("../Main/Blank"));
const Vacancies = lazy(() => import("../Vacancies"));

const SuperAdmin = lazy(() => import("../SuperAdmin"));

const relativePath = (absolutePath) => absolutePath.replace(ROUTES.MAIN + '/', '');

const Main = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    contract,
    role,
    globalloading,
    contractName,
    orgdetails,
    portaldetails,
  } = useSelector((state) => {
    const {
      candidates,
      portaldetails: { selectedContract = {}, missions, orgdetails = {} },
    } = state;

    let contr = false;
    let globalloading = false;
    let contractName = "";

    if (state.auth.role === "keyworker") {
      if (selectedContract && selectedContract.contractID) {
        contr = selectedContract.contractID;
      }
      globalloading = !!(candidates && !candidates.candidates && !missions);
      if (selectedContract && selectedContract.name) {
        contractName = selectedContract.name;
      }
    } else {
      contr = true;
    }

    return {
      contract: contr,
      role: state.auth.role,
      globalloading,
      contractName,
      orgdetails,
      portaldetails: state.portaldetails,
    };
  });

  const [topLoading, setTopLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bg, setBg] = useState(false);
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (globalloading) {
      setTopLoading(true);
      setBg(true);
      setLoading(true);
    } else {
      setTimeout(() => {
        setTopLoading(false);
        setBg(false);
      }, 1000);

      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [globalloading]);

  useEffect(() => {
    if (role === "keyworker" && !portaldetails.missions) {
      setTopLoading(true);
      setBg(true);
      setLoading(true);
    }
    if (!init && location.pathname && location.pathname === ROUTES.MAIN) {
      let defaultRoute;
      if (role === "super-admin") {
        defaultRoute = ROUTES.SUPER_ADMIN;
      } else if (
        role === "hr-manager" ||
        role === "line-manager" ||
        role === "employer-engagement"
      ) {
        defaultRoute = ROUTES.VACANCIES;
      } else {
        defaultRoute = ROUTES.DASHBOARDS;
      }
      if (
        role === "flexible" &&
        portaldetails &&
        portaldetails.user &&
        portaldetails.user.viewPermissions
      ) {
        if (
          portaldetails.user.viewPermissions.dashboardCheckboxGlobal ||
          portaldetails.user.viewPermissions.dashboardCheckbox
        ) {
          defaultRoute = ROUTES.DASHBOARDS;
        } else if (portaldetails.user.viewPermissions.vacancyCheckbox) {
          defaultRoute = ROUTES.VACANCIES;
        } else if (portaldetails.user.viewPermissions.candidateCheckbox) {
          defaultRoute = ROUTES.CANDIDATES;
        } else if (portaldetails.user.viewPermissions.caseloadCheckbox) {
          defaultRoute = ROUTES.CASELOADS;
        }
      }
      if (defaultRoute) {
        setInit(true);
        navigate(defaultRoute);
      }
    }
  }, [role, portaldetails, init, location, navigate]);

  useEffect(() => {
    Cache.setItem("lastpath", location.pathname);
  }, [location]);


  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ mt: 6, mb: 2 }}>
          {loading && (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 9999,
                backgroundColor: bg ? "#efefef" : "transparent",
              }}
            >
              <Fade in={topLoading}>
                <Box
                  sx={{
                    backgroundColor: "#efefef",
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    zIndex: 9999,
                  }}
                >
                  <LinearProgress />
                  <Zoom in={true}>
                    <Box
                      sx={{
                        width: 300,
                        height: 200,
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        ml: -18.75,
                        mt: -25,
                      }}
                    >
                      <Avatar
                        variant="square"
                        src={
                          config.STORAGE_CLOUDFRONT_URL +
                          (orgdetails.orgLogoURL
                            ? orgdetails.orgLogoURL + "?"
                            : "/logos/default_portal_org_logo.png?") +
                          Date.now()
                        }
                        sx={{ width: 150, height: 150, ml: 9.375 }}
                      />
                      <CircularProgress
                        sx={{ ml: 17.125, mt: 1.875 }}
                        size={26}
                      />
                      <Typography
                        variant="subtitle1"
                        gutterBottom
                        justifyContent="center"
                        sx={{ mt: 1.875, textAlign: "center" }}
                      >
                        Loading... {contractName}
                      </Typography>
                    </Box>
                  </Zoom>
                </Box>
              </Fade>
            </Box>
          )}
          <Navigation />
          {contract && (
            <Suspense fallback={<LinearProgress />}>
              <Routes>
                <Route path={relativePath(`${ROUTES.INSIGHTS}/*`)} element={<Insights />} />
                <Route path={relativePath(`${ROUTES.VACANCIES}/*`)} element={<Vacancies />} />
                <Route path={relativePath(`${ROUTES.WORKFORCE_PLANNING}/*`)} element={<WorkforcePlanning />} />
                <Route path={relativePath(`${ROUTES.DASHBOARDS}/*`)} element={<MainDashboard />} />
                <Route path={relativePath(`${ROUTES.ADMIN}/*`)} element={<Admin />} />
                <Route path={relativePath(`${ROUTES.CASELOADS}/*`)} element={<Caseloads />} />
                <Route path={relativePath(`${ROUTES.SUPER_ADMIN}/*`)} element={<SuperAdmin />} />
                <Route path={relativePath(ROUTES.PROFILE)} element={<Profile />} />
                <Route path={relativePath(ROUTES.FAQ)} element={<Faq />} />
                <Route path={relativePath(ROUTES.CANDIDATES)} element={<Candidates />} />
                <Route path={relativePath(ROUTES.EMPLOYEES)} element={<Candidates isInternal={true} />} />
              </Routes>
            </Suspense>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Main;
